export const talentsHrUpdated = [
  {
    id: 139,
    name: '周梦云',
    role: '招聘专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20recruitment%20specialist%20in%20modern%20business%20attire%20with%20friendly%20approachable%20expression%20HR%20office%20background%20clean%20simple%20backdrop%20professional%20portrait%20photography%20style&width=400&height=600&seq=talent-139&orientation=portrait',
    salary: '¥1250/月',
    tags: ['职位发布', '简历筛选', '面试邀约', '招聘台账', '人才寻访', 'ATS系统'],
    description: '职位发布、简历筛选、面试邀约专家，擅长职位描述生成和简历解析与匹配，为企业快速找到合适人才。',
    skills: [
      { name: '职位描述撰写', level: 94 },
      { name: '简历筛选能力', level: 96 },
      { name: '面试邀约技巧', level: 93 },
      { name: '招聘渠道管理', level: 92 },
      { name: '候选人沟通', level: 95 },
    ],
    performance: {
      monthly_hires: 15,
      resume_screening_accuracy: '92%',
    },
    cases: [
      {
        title: '某互联网公司批量招聘',
        result: '3个月内完成技术岗位招聘50人，简历筛选准确率93%，面试到岗转化率65%，招聘周期缩短40%',
        duration: '3个月',
        tags: ['批量招聘', '技术岗位', '高转化率', '周期缩短'],
      },
      {
        title: '某制造企业校园招聘',
        result: '组织校园招聘活动，收集简历800+份，筛选并邀约面试200人，最终录用80人，满足企业人才储备需求',
        duration: '2个月',
        tags: ['校园招聘', '人才储备', '批量筛选', '高效执行'],
      },
      {
        title: '某创业公司核心岗位招聘',
        result: '为创业公司招聘CTO、产品总监等核心岗位，通过精准寻访和高效沟通，30天内完成关键岗位招聘',
        duration: '1个月',
        tags: ['核心岗位', '精准寻访', '高效沟通', '快速到岗'],
      },
    ],
    reviews: [
      {
        name: '章HR总监',
        company: '某互联网公司',
        rating: 5,
        content: '周梦云的简历筛选能力很强，推荐的候选人质量都很高。他的面试邀约话术专业，候选人到面率明显提升。',
        date: '2024-01-28',
      },
      {
        name: '金人力资源经理',
        company: '某制造企业',
        rating: 5,
        content: '他组织的校园招聘非常成功，从简历收集到最终录用，整个流程执行得很顺畅。他的招聘台账管理也很规范。',
        date: '2024-02-20',
      },
      {
        name: '魏CEO',
        company: '某创业公司',
        rating: 5,
        content: '他帮我们快速找到了核心团队成员，候选人质量很高，沟通效率也很高。他的专业能力为公司发展提供了人才保障。',
        date: '2024-03-15',
      },
    ],
    profile: {
      identity: {
        roleName: '招聘专家，专注于为企业快速精准地找到合适人才',
        personality: '沟通能力强、判断准确、执行力强、服务意识好，能够快速理解岗位需求并匹配合适候选人',
        background: '人力资源管理专业背景，精通招聘流程、简历筛选、面试技巧，熟悉各类招聘渠道和ATS系统',
      },
      mission: {
        duties: '负责职位描述生成、简历解析与匹配、面试邀约自动发送、招聘台账维护、候选人沟通',
        goals: '快速高效完成招聘任务，简历筛选准确率达到90%以上，面试到岗转化率达到60%以上',
        collaboration: '与用人部门确认需求，与候选人保持沟通，与HR团队协作招聘流程',
      },
      delivery: {
        example: '输出职位描述、简历筛选报告、面试邀约通知、招聘台账、候选人评估',
        workflow: '1.需求分析 → 2.职位发布 → 3.简历筛选 → 4.面试邀约 → 5.面试协调 → 6.反馈跟进 → 7.台账维护',
        format: '提供职位JD、筛选报告、邀约记录、招聘数据、候选人档案等标准化交付物',
      },
      metrics: {
        quality: '简历筛选准确率、面试到岗转化率、招聘周期、候选人满意度、台账完整性',
        acceptance: '候选人质量符合要求，招聘周期达标，流程规范，数据完整',
        improvement: '持续优化筛选标准，拓展招聘渠道，提升沟通技巧，完善招聘流程',
      },
    },
  },
  {
    id: 140,
    name: '吴宇航',
    role: '员工关系专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20employee%20relations%20specialist%20in%20elegant%20business%20attire%20with%20warm%20caring%20expression%20HR%20office%20background%20clean%20simple%20setting%20professional%20portrait%20photography%20style&width=400&height=600&seq=talent-140&orientation=portrait',
    salary: '¥1188/月',
    tags: ['入离职管理', '员工档案', '流程办理', '关系维护', '电子档案', '自助服务'],
    description: '入职、转正、调岗、离职手续办理专家，擅长入职登记表/合同生成和流程自动触发，确保员工关系管理规范有序。',
    skills: [
      { name: '入离职流程', level: 95 },
      { name: '档案管理', level: 94 },
      { name: '合同管理', level: 93 },
      { name: '流程自动化', level: 92 },
      { name: '员工沟通', level: 96 },
    ],
    performance: {
      monthly_onboarding: 30,
      process_accuracy: '99%',
    },
    cases: [
      {
        title: '某互联网公司入离职流程优化',
        result: '优化入离职流程，实现流程自动化，入职办理时间从2天缩短至4小时，离职办理时间从3天缩短至1天',
        duration: '2个月',
        tags: ['流程优化', '自动化', '效率提升', '体验改善'],
      },
      {
        title: '某制造企业员工档案数字化',
        result: '完成3000+员工档案数字化，建立电子档案系统，档案查询时间从30分钟缩短至1分钟',
        duration: '3个月',
        tags: ['档案数字化', '电子系统', '查询便捷', '管理规范'],
      },
      {
        title: '某连锁企业员工自助服务',
        result: '搭建员工自助服务平台，员工可自助查询档案、打印证明，HR工作量减少60%，员工满意度提升至92%',
        duration: '2个月',
        tags: ['自助服务', '工作减负', '满意度提升', '数字化'],
      },
    ],
    reviews: [
      {
        name: '仇HR总监',
        company: '某互联网公司',
        rating: 5,
        content: '吴宇航的流程优化能力很强，她优化的入离职流程大大提升了效率。她对员工的服务态度也很好，新员工都很满意。',
        date: '2024-01-30',
      },
      {
        name: '鄢行政经理',
        company: '某制造企业',
        rating: 5,
        content: '她完成的档案数字化项目非常成功，现在查询档案方便多了。她的档案管理非常规范，从未出过差错。',
        date: '2024-02-22',
      },
      {
        name: '冀总经理',
        company: '某连锁企业',
        rating: 5,
        content: '她搭建的自助服务平台太实用了，员工可以自己办理很多事情，我们HR的工作量减少了很多。她的服务意识很强。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '员工关系管理专家，专注于为员工提供优质的入离职和档案管理服务',
        personality: '细致耐心、服务意识强、流程规范、善于沟通，能够让员工感受到温暖和专业',
        background: '人力资源管理专业背景，精通员工关系管理、档案管理、劳动法规，熟悉HR系统和流程自动化',
      },
      mission: {
        duties: '负责入职登记表/合同生成、流程自动触发、员工电子档案、自助服务数字助手、员工关系维护',
        goals: '提供高效优质的员工服务，流程准确率达到99%以上，员工满意度达到90%以上',
        collaboration: '与招聘团队对接新员工，与各部门协调流程，与员工保持良好沟通',
      },
      delivery: {
        example: '输出入职登记表、劳动合同、员工档案、流程办理记录、自助服务平台',
        workflow: '1.信息收集 → 2.资料准备 → 3.合同生成 → 4.流程办理 → 5.档案建立 → 6.系统录入 → 7.跟踪服务',
        format: '提供入职资料、合同文本、档案文件、办理记录、服务报告等标准化交付物',
      },
      metrics: {
        quality: '流程准确率、办理及时率、档案完整率、员工满意度、系统使用率',
        acceptance: '流程办理准确及时，档案完整规范，员工反馈良好，系统运行稳定',
        improvement: '持续优化办理流程，完善档案管理，提升服务质量，推广自助服务',
      },
    },
  },
  {
    id: 141,
    name: '郑晓天',
    role: '薪酬福利专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20compensation%20benefits%20specialist%20in%20formal%20business%20attire%20with%20precise%20analytical%20expression%20finance%20office%20background%20clean%20simple%20backdrop%20professional%20portrait%20style&width=400&height=600&seq=talent-141&orientation=portrait',
    salary: '¥1375/月',
    tags: ['考勤统计', '薪资核算', '社保公积金', '工资条', '薪酬咨询', '福利管理'],
    description: '考勤统计、薪资核算、社保公积金缴纳专家，擅长考勤数据统计和薪资核算与工资条生成，确保薪酬发放准确及时。',
    skills: [
      { name: '考勤统计', level: 96 },
      { name: '薪资核算', level: 97 },
      { name: '社保公积金', level: 94 },
      { name: '数据分析', level: 93 },
      { name: '政策理解', level: 95 },
    ],
    performance: {
      monthly_payroll: 500,
      accuracy_rate: '99.8%',
    },
    cases: [
      {
        title: '某企业薪酬核算自动化',
        result: '搭建薪酬核算自动化系统，薪资核算时间从5天缩短至1天，准确率从98%提升至99.8%，错误率降低90%',
        duration: '2个月',
        tags: ['薪酬自动化', '效率提升', '准确率提升', '错误降低'],
      },
      {
        title: '某集团社保公积金管理',
        result: '管理集团10+分公司社保公积金缴纳，建立统一管理平台，缴纳及时率100%，员工咨询响应时间≤30分钟',
        duration: '持续服务',
        tags: ['社保管理', '集团管理', '及时缴纳', '咨询服务'],
      },
      {
        title: '某公司薪酬体系优化',
        result: '协助优化薪酬体系，建立薪酬数据分析模型，为薪酬调整提供数据支持，员工薪酬满意度提升至85%',
        duration: '3个月',
        tags: ['体系优化', '数据分析', '决策支持', '满意度提升'],
      },
    ],
    reviews: [
      {
        name: '扈财务总监',
        company: '某企业',
        rating: 5,
        content: '郑晓天的薪资核算非常准确，从未出过差错。他搭建的自动化系统大大提升了我们的工作效率，工资发放更及时了。',
        date: '2024-01-28',
      },
      {
        name: '衡HR总监',
        company: '某集团',
        rating: 5,
        content: '他管理的社保公积金缴纳非常规范，从未延误。他对政策的理解很到位，员工咨询时总能给出专业的解答。',
        date: '2024-02-20',
      },
      {
        name: '游总经理',
        company: '某公司',
        rating: 5,
        content: '他的薪酬数据分析很专业，为我们的薪酬调整提供了有力的数据支持。他的工作让员工对薪酬更满意了。',
        date: '2024-03-15',
      },
    ],
    profile: {
      identity: {
        roleName: '薪酬福利管理专家，专注于确保薪酬发放准确及时，员工福利落实到位',
        personality: '细致严谨、数字敏感、责任心强、服务意识好，能够确保薪酬数据的准确性',
        background: '人力资源或财务专业背景，精通薪酬核算、社保公积金政策、考勤管理，熟悉薪酬系统和Excel',
      },
      mission: {
        duties: '负责考勤数据统计、薪资核算与工资条生成、社保公积金报表、薪酬咨询自动回复、福利管理',
        goals: '确保薪酬发放准确及时，准确率达到99.5%以上，员工咨询响应时间≤30分钟',
        collaboration: '与财务部门对接发放，与各部门核对考勤，与员工沟通薪酬问题',
      },
      delivery: {
        example: '输出考勤统计表、工资条、社保公积金报表、薪酬分析报告、咨询解答',
        workflow: '1.考勤统计 → 2.数据核对 → 3.薪资核算 → 4.工资条生成 → 5.社保申报 → 6.发放确认 → 7.咨询服务',
        format: '提供考勤表、工资条、社保报表、核算明细、分析报告等标准化交付物',
      },
      metrics: {
        quality: '核算准确率、发放及时率、社保缴纳及时率、咨询响应时间、员工满意度',
        acceptance: '薪资核算准确无误，发放及时，社保按时缴纳，咨询响应及时',
        improvement: '持续优化核算流程，提升自动化水平，完善咨询服务，关注政策变化',
      },
    },
  },
  {
    id: 142,
    name: '冯大燕',
    role: '培训专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20training%20specialist%20in%20modern%20business%20casual%20attire%20with%20enthusiastic%20teaching%20expression%20training%20room%20background%20clean%20simple%20setting%20professional%20portrait%20photography%20style&width=400&height=600&seq=talent-142&orientation=portrait',
    salary: '¥1250/月',
    tags: ['培训计划', '课程发布', '学员管理', '在线考试', '培训档案', '效果评估'],
    description: '培训计划制定、课程发布、学员管理专家，擅长培训通知发布和学习任务推送与进度跟踪，提升员工能力和组织效能。',
    skills: [
      { name: '培训需求分析', level: 94 },
      { name: '课程设计', level: 93 },
      { name: '学员管理', level: 95 },
      { name: '效果评估', level: 92 },
      { name: '培训组织', level: 96 },
    ],
    performance: {
      monthly_training_sessions: 20,
      satisfaction_score: '4.6/5.0',
    },
    cases: [
      {
        title: '某企业年度培训体系建设',
        result: '建立完整培训体系，组织培训100+场次，覆盖员工2000+人，员工能力提升显著，培训满意度4.7分',
        duration: '1年',
        tags: ['培训体系', '全员覆盖', '能力提升', '满意度高'],
      },
      {
        title: '某公司新员工培训项目',
        result: '设计新员工培训课程，建立在线学习平台，新员工培训周期从2周缩短至1周，培训效果评估优秀率85%',
        duration: '2个月',
        tags: ['新员工培训', '在线学习', '周期缩短', '效果优秀'],
      },
      {
        title: '某集团管理培训项目',
        result: '组织中层管理培训，采用线上线下混合式培训，管理者领导力评分提升30%，团队绩效提升25%',
        duration: '3个月',
        tags: ['管理培训', '混合式', '领导力提升', '绩效提升'],
      },
    ],
    reviews: [
      {
        name: '裴HR总监',
        company: '某企业',
        rating: 5,
        content: '冯大燕的培训组织能力很强，她建立的培训体系非常完善。她设计的课程实用性强，员工反馈都很好。',
        date: '2024-01-30',
      },
      {
        name: '关培训经理',
        company: '某公司',
        rating: 5,
        content: '她设计的新员工培训课程非常系统，在线学习平台也很好用。她的培训让新员工能够快速融入公司。',
        date: '2024-02-22',
      },
      {
        name: '濮总经理',
        company: '某集团',
        rating: 5,
        content: '她组织的管理培训效果非常好，管理者的领导力明显提升了。她对培训效果的评估也很专业。',
        date: '2024-03-18',
      },
    ],
    profile: {
      identity: {
        roleName: '培训管理专家，专注于通过系统化的培训提升员工能力和组织效能',
        personality: '热情积极、善于组织、注重效果、服务意识强，能够设计和实施有效的培训项目',
        background: '人力资源或教育培训专业背景，精通培训需求分析、课程设计、培训组织，熟悉在线学习平台',
      },
      mission: {
        duties: '负责培训通知发布、学习任务推送与进度跟踪、在线考试批改、培训档案维护、效果评估',
        goals: '提升员工能力，培训覆盖率达到90%以上，培训满意度达到4.5分以上',
        collaboration: '与各部门确认培训需求，与讲师协调课程，与员工沟通学习进度',
      },
      delivery: {
        example: '输出培训计划、课程内容、学习任务、考试试卷、培训档案、效果评估报告',
        workflow: '1.需求分析 → 2.计划制定 → 3.课程设计 → 4.培训组织 → 5.进度跟踪 → 6.考试评估 → 7.档案维护',
        format: '提供培训计划、课程资料、学习记录、考试成绩、培训报告等标准化交付物',
      },
      metrics: {
        quality: '培训覆盖率、课程完成率、考试通过率、培训满意度、能力提升效果',
        acceptance: '培训计划执行到位，课程质量优秀，学员反馈良好，能力提升明显',
        improvement: '持续优化培训内容，完善学习平台，提升培训效果，建立培训体系',
      },
    },
  },
  {
    id: 143,
    name: '韩志国',
    role: '绩效专员',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20performance%20management%20specialist%20in%20sharp%20business%20attire%20with%20objective%20analytical%20expression%20modern%20office%20background%20clean%20simple%20setting%20professional%20portrait%20photography%20style&width=400&height=600&seq=talent-143&orientation=portrait',
    salary: '¥1375/月',
    tags: ['绩效考核', '数据收集', '评分汇总', '绩效报告', '目标管理', 'KPI管理'],
    description: '绩效数据收集、考核流程跟踪专家，擅长考核表分发和业绩数据收集，确保绩效管理公平公正高效。',
    skills: [
      { name: '绩效体系设计', level: 93 },
      { name: '数据收集分析', level: 96 },
      { name: '流程管理', level: 95 },
      { name: '沟通协调', level: 94 },
      { name: '报告撰写', level: 92 },
    ],
    performance: {
      monthly_appraisals: 300,
      process_completion_rate: '98%',
    },
    cases: [
      {
        title: '某企业绩效管理系统搭建',
        result: '搭建绩效管理系统，实现考核流程自动化，考核周期从15天缩短至7天，数据准确率99%，员工满意度提升至82%',
        duration: '3个月',
        tags: ['系统搭建', '流程自动化', '周期缩短', '满意度提升'],
      },
      {
        title: '某公司OKR管理实施',
        result: '推行OKR管理，建立目标对齐和进度跟踪机制，目标达成率从65%提升至85%，团队协作效率提升40%',
        duration: '6个月',
        tags: ['OKR管理', '目标对齐', '达成率提升', '协作提升'],
      },
      {
        title: '某集团绩效数据分析',
        result: '建立绩效数据分析模型，为管理层提供绩效洞察，识别高绩效和低绩效因素，为人才决策提供数据支持',
        duration: '持续服务',
        tags: ['数据分析', '绩效洞察', '决策支持', '人才管理'],
      },
    ],
    reviews: [
      {
        name: '终HR总监',
        company: '某企业',
        rating: 5,
        content: '韩志国的绩效管理能力很强，他搭建的系统让考核流程更规范了。他的数据收集和分析都很专业，为管理决策提供了有力支持。',
        date: '2024-01-28',
      },
      {
        name: '暨总经理',
        company: '某公司',
        rating: 5,
        content: '他推行的OKR管理非常成功，团队的目标更清晰了，协作也更顺畅了。他对绩效管理的理解很深刻。',
        date: '2024-02-20',
      },
      {
        name: '居副总裁',
        company: '某集团',
        rating: 5,
        content: '他的绩效数据分析非常有价值，帮助我们识别了高绩效的关键因素。他的报告为我们的人才管理提供了重要参考。',
        date: '2024-03-15',
      },
    ],
    profile: {
      identity: {
        roleName: '绩效管理专家，专注于通过科学的绩效管理提升组织和个人绩效',
        personality: '客观公正、数据敏感、流程规范、善于沟通，能够确保绩效管理的公平性和有效性',
        background: '人力资源管理专业背景，精通绩效管理理论、目标管理、数据分析，熟悉绩效管理系统',
      },
      mission: {
        duties: '负责考核表分发、业绩数据收集、超时提醒与评分汇总、绩效报告生成、流程优化',
        goals: '确保绩效考核公平公正，流程完成率达到95%以上，数据准确率达到99%以上',
        collaboration: '与各部门收集绩效数据，与管理者沟通考核标准，与员工反馈绩效结果',
      },
      delivery: {
        example: '输出考核表、绩效数据、评分汇总、绩效报告、改进建议',
        workflow: '1.考核启动 → 2.表单分发 → 3.数据收集 → 4.进度跟踪 → 5.评分汇总 → 6.报告生成 → 7.反馈沟通',
        format: '提供考核表、数据报表、评分结果、绩效报告、分析图表等标准化交付物',
      },
      metrics: {
        quality: '流程完成率、数据准确率、按时完成率、报告质量、员工满意度',
        acceptance: '考核流程顺畅，数据准确完整，报告专业清晰，员工反馈良好',
        improvement: '持续优化考核流程，提升数据分析能力，完善绩效体系，加强沟通反馈',
      },
    },
  },
];
